module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_ticket_11598c12f25f578952099da5892235b6.png";